"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastMileDeliveryMixin = void 0;

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.number.constructor");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _userLogs = require("@/mixins/user-logs/user-logs");

var _route = require("@/api/route.api");

var _lastMileV = require("@/api/last-mile-v2.api");

var _socketV = require("@/api/socket-v2.api");

var _plan = require("@/api/plan.api");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_TRUCK_WORKING_HOURS = [process.env.VUE_APP_DEFAULT_START_WORKINGHR, process.env.VUE_APP_DEFAULT_END_WORKINGHR];

var LastMileDeliveryMixin = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LastMileDeliveryMixin, _Mixins);

  var _super = _createSuper(LastMileDeliveryMixin);

  function LastMileDeliveryMixin() {
    var _this;

    (0, _classCallCheck2.default)(this, LastMileDeliveryMixin);
    _this = _super.apply(this, arguments);
    _this.disableTruckKey = process.env.VUE_APP_DISABLE_TRUCK_KEY;
    return _this;
  } // disableTruckList: any[] = [];


  (0, _createClass2.default)(LastMileDeliveryMixin, [{
    key: "isViewOnly",
    get: function get() {
      /*const isAdmin = this.$userInformation.isAdmin;
      const permissionList = this.helper.get(this.$userInformation, 'user.permission', []);
      let isModifyAllowed: boolean = false;
       if (permissionList.length > 0) {
          const isModify = Boolean(
              this.helper.get(
                  permissionList.filter((i) => i.Value === '0900'),
                  '0.Modify',
                  false
              )
          );
          const isAccess = Boolean(
              this.helper.get(
                  permissionList.filter((i) => i.Value === '0900'),
                  '0.Access',
                  false
              )
          );
           isModifyAllowed = isAdmin || isModify || !(!isModify && isAccess);
      }
       return !isModifyAllowed || this.isOccupied;*/
      return this.isOccupied;
    }
  }, {
    key: "isOccupied",
    get: function get() {
      return this.$isOccupied;
    },
    set: function set(newVal) {
      this.$setIsOccupied(newVal);
    }
  }, {
    key: "occupyingUsername",
    get: function get() {
      return this.$occupyingUsername;
    },
    set: function set(newVal) {
      this.$setOccupyingUsername(newVal);
    }
  }, {
    key: "occupyingRoute",
    get: function get() {
      return this.$occupyingRoute;
    },
    set: function set(newVal) {
      this.$setOccupyingRoute(newVal);
    }
  }, {
    key: "occupyingMessage",
    get: function get() {
      var routeUser = this.occupyingUsername ? this.occupyingUsername : this.$t('planning.messages.someone');
      var routeName = this.occupyingRoute === 'lmdV2ManualAssign' || this.occupyingRoute === 'lmdPriceriteManualAssign' || this.occupyingRoute === 'lmdWellcomeManualAssign' ? this.$t('planning.messages.manualAssignOccupied') : this.$t('planning.messages.autoAssignOccupied');
      return "".concat(routeUser, " ").concat(routeName);
    }
  }, {
    key: "$socketId",
    get: function get() {
      return this.$store.getters['common/socketId'];
    },
    set: function set(newVal) {
      this.$setSocketId(newVal);
    }
  }, {
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "$isMobile",
    get: function get() {
      return this.$store.getters['common/isMobile'];
    },
    set: function set(newVal) {
      this.$setIsMobile(newVal);
    }
  }, {
    key: "isSomeOrdersAssigned",
    get: function get() {
      if (this.$plan && this.$plan.trucks && this.$plan.trucks.length > 0) {
        return this.$plan.trucks.some(function (truck) {
          return truck.routes.some(function (route) {
            return route.status.toUpperCase() === 'ASSIGNED' || route.status.toUpperCase() === 'COMPLETED';
          });
        });
      }

      return false;
    }
  }, {
    key: "truckPlanIds",
    get: function get() {
      var truck = this.getTruckInPlan(this.$selectedTruck);

      if (this.$selectedTruck && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "disableTruckList",
    get: function get() {
      return this.$store.getters['lastMileV2/disableTruckList'];
    },
    set: function set(newVal) {
      this.$setDisableTruckList(newVal);
    }
  }, {
    key: "$trucks",
    get: function get() {
      return this.$store.getters['lastMileV2/trucks'];
    },
    set: function set(newVal) {
      this.$setTrucks(newVal);
    }
  }, {
    key: "$bufferTrucks",
    get: function get() {
      return this.$store.getters['lastMileV2/bufferTrucks'];
    },
    set: function set(newVal) {
      this.$setBufferTrucks(newVal);
    }
  }, {
    key: "$GLOBAL_ACTIVE_USERS",
    get: function get() {
      return this.$store.getters['lastMileV2/GLOBAL_ACTIVE_USERS'];
    },
    set: function set(newVal) {
      this.$setGlobalActiveUsers(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_ORDERS",
    get: function get() {
      return this.$store.getters['lastMileV2/GLOBAL_SELECTED_ORDERS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedOrders(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_TRUCKS",
    get: function get() {
      return this.$store.getters['lastMileV2/GLOBAL_SELECTED_TRUCKS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedTrucks(newVal);
    }
  }, {
    key: "$failedOrders",
    get: function get() {
      return this.$store.getters['lastMileV2/failedOrders'];
    },
    set: function set(newVal) {
      this.$setFailedOrders(newVal);
    }
  }, {
    key: "$removedTruckIds",
    get: function get() {
      return this.$store.getters['lastMileV2/removedTruckIds'];
    },
    set: function set(newVal) {
      this.$setRemovedTruckIds(newVal);
    }
  }, {
    key: "$orderColumnTemplates",
    get: function get() {
      return this.$store.getters['lastMileV2/orderColumnTemplates'];
    },
    set: function set(newVal) {
      this.$setOrderColumnTemplates(newVal);
    }
  }, {
    key: "isManualAssignLoading",
    get: function get() {
      return this.$store.getters['lastMileV2/isManualAssignLoading'];
    },
    set: function set(newVal) {
      this.$setIsManualAssignLoading(newVal);
    }
  }, {
    key: "isAutoAssignLoading",
    get: function get() {
      return this.$store.getters['lastMileV2/isAutoAssignLoading'];
    },
    set: function set(newVal) {
      this.$setIsAutoAssignLoading(newVal);
    }
  }, {
    key: "$isAssignedDriverChanges",
    get: function get() {
      return this.$store.getters['lastMileV2/isAssignedDriverChanges'];
    },
    set: function set(newVal) {
      this.$setIsAssignedDriverChanges(newVal);
    }
  }, {
    key: "$toBeUnassignedOrderIds",
    get: function get() {
      return this.$store.getters['lastMileV2/toBeUnassignedOrderIds'];
    },
    set: function set(newVal) {
      this.$setToBeUnassignedOrderIds(newVal);
    }
  }, {
    key: "$dateRangeOption",
    get: function get() {
      return this.$store.getters['lastMileV2/dateRangeOption'];
    },
    set: function set(newVal) {
      this.$setDateRangeOption(newVal);
    }
  }, {
    key: "$pagination",
    get: function get() {
      return this.$store.getters['lastMileV2/pagination'];
    },
    set: function set(newVal) {
      this.$setPagination(newVal);
    }
  }, {
    key: "$startDate",
    get: function get() {
      return this.$store.getters['lastMileV2/startDate'];
    },
    set: function set(newVal) {
      this.$setStartDate(newVal);
    }
  }, {
    key: "$endDate",
    get: function get() {
      return this.$store.getters['lastMileV2/endDate'];
    },
    set: function set(newVal) {
      this.$setEndDate(newVal);
    }
  }, {
    key: "$dateRange",
    get: function get() {
      return [this.$startDate, this.$endDate];
    },
    set: function set(newVal) {
      if (newVal) {
        this.$setDateRange({
          startDate: newVal[0],
          endDate: newVal[1]
        });
      }
    }
  }, {
    key: "$planDate",
    get: function get() {
      return this.$store.getters['lastMileV2/planDate'];
    },
    set: function set(newVal) {
      this.$setPlanDate(newVal);
    }
  }, {
    key: "$truckLoading",
    get: function get() {
      return this.$store.getters['lastMileV2/truckLoading'];
    },
    set: function set(newVal) {
      this.$setTruckLoading(newVal);
    }
  }, {
    key: "$locationType",
    get: function get() {
      return this.$store.getters['lastMileV2/locationType'];
    },
    set: function set(newVal) {
      this.$setLocationType(newVal);
    }
  }, {
    key: "$searchType",
    get: function get() {
      return this.$store.getters['lastMileV2/searchType'];
    },
    set: function set(newVal) {
      this.$setSearchType(newVal);
    }
  }, {
    key: "$selectedTruck",
    get: function get() {
      return this.$store.getters['lastMileV2/selectedTruck'];
    },
    set: function set(newVal) {
      this.$setSelectedTruck(newVal);
    }
  }, {
    key: "$selectedLocation",
    get: function get() {
      return this.$store.getters['lastMileV2/selectedLocation'];
    },
    set: function set(newVal) {
      this.$setSelectedLocation(newVal);
    }
  }, {
    key: "$unassignedOrders",
    get: function get() {
      return this.$store.getters['lastMileV2/unassignedOrders'];
    },
    set: function set(newVal) {
      this.$setUnassignedOrders(newVal);
    }
  }, {
    key: "$excludedOrders",
    get: function get() {
      return this.$store.getters['lastMileV2/excludedOrders'];
    },
    set: function set(newVal) {
      this.$setExcludedOrders(newVal);
    }
  }, {
    key: "$includedOrders",
    get: function get() {
      return this.$store.getters['lastMileV2/includedOrders'];
    },
    set: function set(newVal) {
      this.$setIncludedOrders(newVal);
    }
  }, {
    key: "$selectedOrders",
    get: function get() {
      return this.$store.getters['lastMileV2/selectedOrders'];
    },
    set: function set(newVal) {
      this.$setSelectedOrders(newVal);
    }
  }, {
    key: "$orderFilters",
    get: function get() {
      return this.$store.getters['lastMileV2/orderFilters'];
    },
    set: function set(newVal) {
      this.$setOrderFilters(newVal);
    }
  }, {
    key: "$selectedColumns",
    get: function get() {
      return this.$store.getters['lastMileV2/selectedColumns'];
    },
    set: function set(newVal) {
      this.$setSelectedColumns(newVal);
    }
  }, {
    key: "driversList",
    get: function get() {
      var _this2 = this;

      return this.helper.orderBy(this.$drivers, [function (driver) {
        return driver['UserName'].toLowerCase();
      }], ['asc']).filter(function (driver) {
        return !_this2.blockedDrivers.includes(driver.RecId);
      });
    }
  }, {
    key: "$selectedDriver",
    get: function get() {
      return this.$store.getters['lastMileV2/selectedDriver'];
    },
    set: function set(newVal) {
      this.$setSelectedDriver(newVal);
    }
  }, {
    key: "$anyChanges",
    get: function get() {
      return this.$store.getters['lastMileV2/anyChanges'];
    },
    set: function set(newVal) {
      this.$setAnyChanges(newVal);
    }
  }, {
    key: "$isPlanExists",
    get: function get() {
      return this.$store.getters['lastMileV2/isPlanExists'];
    },
    set: function set(newVal) {
      this.$setPlanExists(newVal);
    }
  }, {
    key: "locked",
    get: function get() {
      var _this3 = this;

      return this.helper.get(this.helper.filter(this.$trucks, function (truck) {
        return truck['id'] === _this3.$selectedTruck;
      }), '0.locked', true);
    },
    set: function set(newVal) {
      var _this4 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this4.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['locked'] = newVal;
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "currTruck",
    get: function get() {
      var _this5 = this;

      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === _this5.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "currPlanTruck",
    get: function get() {
      var _this6 = this;

      if (!this.$plan.trucks || this.$plan.trucks.length === 0) {
        return null;
      }

      return this.helper.get(this.$plan.trucks.filter(function (tData) {
        return tData['truckId'] === _this6.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "$truckFilters",
    get: function get() {
      return this.$store.getters['lastMileV2/truckFilters'];
    },
    set: function set(newVal) {
      this.$setTruckFilters(newVal);
    }
  }, {
    key: "blockedDrivers",
    get: function get() {
      return this.helper.get(this.$userInformation, 'blockedDrivers', []);
    }
  }, {
    key: "routes",
    get: function get() {
      return this.getRoutes(this.$selectedTruck);
    },
    set: function set(newVal) {
      var _this7 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this7.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['routes'] = newVal;
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "$defaultTime",
    get: function get() {
      var startTime = this.$userSetting['default6'] || null;

      if (startTime) {
        return (0, _moment.default)(new Date()).format('YYYY-MM-DD') === this.$planDate ? (0, _moment.default)(new Date()).format("YYYY-MM-DD ".concat(startTime)) : (0, _moment.default)(this.$planDate).format("YYYY-MM-DD ".concat(startTime));
      }

      return (0, _moment.default)(new Date()).format('YYYY-MM-DD') === this.$planDate ? (0, _moment.default)(new Date()).format('YYYY-MM-DD HH:mm:00') : (0, _moment.default)(this.$planDate).format('YYYY-MM-DD 09:00:00');
    }
  }, {
    key: "hasToteboxDry",
    get: function get() {
      var bool = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity4', default12)) {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "hasToteboxWet",
    get: function get() {
      var bool = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity5', default12)) {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "hasAssemblyMinutes",
    get: function get() {
      var hasAssemblyMinute = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity3', default12)) {
        hasAssemblyMinute = true;
      }

      return hasAssemblyMinute;
    }
  }, {
    key: "hasPallets",
    get: function get() {
      var bool = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity6', default12)) {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "$pickUpAllFirst",
    get: function get() {
      return this.$store.getters['lastMileV2/pickUpAllFirst'];
    },
    set: function set(newVal) {
      this.$setPickUpAllFirst(newVal);
    }
  }, {
    key: "$timeWindowPriority",
    get: function get() {
      return this.$store.getters['lastMileV2/timeWindowPriority'];
    },
    set: function set(newVal) {
      this.$setTimeWindowPriority(newVal);
    }
  }, {
    key: "$timeWindowBuffer",
    get: function get() {
      return this.$store.getters['lastMileV2/timeWindowBuffer'];
    },
    set: function set(newVal) {
      this.$setTimeWindowBuffer(newVal);
    }
  }, {
    key: "$adjustETA",
    get: function get() {
      return this.$store.getters['lastMileV2/adjustETA'];
    },
    set: function set(newVal) {
      this.$setAdjustETA(newVal);
    }
  }, {
    key: "$currTruckPlanId",
    get: function get() {
      return this.$store.getters['lastMileV2/currTruckPlanId'];
    },
    set: function set(newVal) {
      this.$setCurrTruckPlanId(newVal);
    }
  }, {
    key: "$isEnableAllTrucks",
    get: function get() {
      return this.$store.getters['lastMileV2/isEnableAllTrucks'];
    },
    set: function set(newVal) {
      this.$setIsEnableAllTrucks(newVal);
    }
  }, {
    key: "created",
    value: function created() {
      if (!this.routeAPI) {
        this.routeAPI = new _route.RouteAPI({
          customerKey: this.$userInformation.customerKey || '',
          userSetting: this.$userSetting
        });
      }

      if (!this.lastMileDeliveryAPI) {
        this.lastMileDeliveryAPI = new _lastMileV.LastMileV2API({
          customerKey: this.$userInformation.customerKey || '',
          userInformation: this.$userInformation,
          userSetting: this.$userSetting,
          lfToken: this.$lfToken || null
        });
      }

      if (!this.socketAPI) {
        this.socketAPI = new _socketV.SocketAPI({
          lfToken: this.$lfToken || '',
          customerKey: this.$userInformation.customerKey || ''
        });
      }

      if (!this.planAPI) {
        this.planAPI = new _plan.PlanAPI({
          userSetting: this.$userSetting,
          lfCustKey: this.$lfCustKey || null,
          lfAPIToken: this.$lfAPIToken || null
        });
      }
    }
  }, {
    key: "getOrders",
    value: function getOrders() {
      var _this8 = this;

      var orderData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'save';
      var finalOrders = [];

      switch (type) {
        case 'save':
          if (orderData['data'] && orderData['data'].length >= 1) {
            orderData['data'].forEach(function (oData) {
              if (oData['routes'] && oData['routes'].length >= 1) {
                oData['routes'].forEach(function (rData) {
                  var finalOrder = finalOrders.length >= 1 ? finalOrders.find(function (fOrder) {
                    return fOrder['planId'] === rData['planId'];
                  }) : null;

                  if (finalOrder) {
                    finalOrder['orderId'] = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(finalOrder['orderId']), (0, _toConsumableArray2.default)(rData['orderId']))));
                  } else {
                    if (rData['planId'] && rData['orderId']) {
                      finalOrders.push({
                        planCode: code,
                        planId: rData['planId'],
                        orderId: (0, _toConsumableArray2.default)(new Set(rData['orderId']))
                      });
                    }
                  }
                });
              }
            });
          }

          break;

        case 'deleteAll':
          if (orderData['orders'] && orderData['orders'].length >= 1) {
            var orderIds = orderData['orders'].reduce(function (orderId, oData) {
              if (oData['id']) {
                orderId.push(oData['id']);
              }

              return orderId;
            }, []);
            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: orderIds
            });
          }

          break;

        case 'deleteTruck':
          if (orderData['trucks'] && orderData['trucks'].length >= 1) {
            var _orderIds = orderData['trucks'].reduce(function (orderId, oData) {
              if (oData['orderId'].length >= 1 && oData['truckId'] === _this8.$selectedTruck) {
                orderId = [].concat((0, _toConsumableArray2.default)(orderId), (0, _toConsumableArray2.default)(oData['orderId']));
              }

              return orderId;
            }, []);

            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: _orderIds
            });
          }

          break;

        case 'deleteOnList':
          if (orderData['orderId'] && orderData['orderId'].length >= 1) {
            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: orderData['orderId']
            });
          }

          break;
      }

      if (this.$includedOrders && this.$includedOrders.length >= 1) {
        finalOrders.push({
          planCode: '',
          planId: '',
          orderId: this.$includedOrders
        });
      }

      return finalOrders;
    }
  }, {
    key: "isInvalidOrder",
    value: function isInvalidOrder(order) {
      var bool = false;

      if (order.waypoints && order.waypoints.length >= 2) {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          return true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          return true;
        }

        if (this.$userData.checkReadyToShip && !this.$userData.orderAssignmentReadyToShip && (!order['readyToShip'] || order['readyToShip'] === false)) {
          return true;
        }

        this.helper.forEach(order['waypoints'], function (waypoint) {
          /*let isAssemblyTimeInvalid: boolean = false;
          let isToteBoxInvalid: boolean = false;
           if (!this.helper.isUndefined(this.$userSetting.default12)) {
              const additionalConstraints = this.$userSetting.default12.split('|');
              isAssemblyTimeInvalid = additionalConstraints.includes('capacity3') ? parseInt(order['assemblyMinutes'], 10) === 0 : false;
              isToteBoxInvalid = additionalConstraints.includes('capacity4') || additionalConstraints.includes('capacity5') ?
                  parseInt(order['toteBoxDry'], 10) === 0 && parseInt(order['toteBoxWet'], 10) === 0 :
                  false;
          }*/
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0 || parseFloat(order['weight']) === 0 && parseFloat(order['volume']) === 0 // isToteBoxInvalid ||
          // isAssemblyTimeInvalid
          ) {
            bool = true;
          }
        });
      } else {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "getInvalidOrderDetails",
    value: function getInvalidOrderDetails(order) {
      var reason = {
        reason1: false,
        reason2: false,
        reason3: false,
        reason4: false,
        reason5: false,
        reason6: false,
        reason7: false,
        reason8: false,
        reason9: false,
        reason10: false,
        reason11: false
      };

      if (order['waypoints'].length < 2) {
        reason.reason1 = true;
      } else {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          reason.reason2 = true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          reason.reason2 = true;
        }

        this.helper.forEach(order['waypoints'], function (waypoint) {
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0) {
            reason.reason3 = true;
          }

          if (parseFloat(order['volume']) === 0) {
            reason.reason4 = true;
          }

          if (parseFloat(order['weight']) === 0) {
            reason.reason5 = true;
          }
        });

        if (this.helper.some(order['waypoints'], function (i) {
          return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
        })) {
          reason.reason6 = true;
        }
        /*const additionalConstraints = this.$userSetting.default12.split('|');
        if (additionalConstraints.includes('capacity3')) {
            reason.reason7 = parseInt(order['assemblyMinutes'], 10) === 0;
        }*/

        /*if (additionalConstraints.includes('capacity4')) {
            reason.reason8 = parseInt(order['toteBoxDry'], 10) === 0;
        }
         if (additionalConstraints.includes('capacity5')) {
            reason.reason9 = parseInt(order['toteBoxWet'], 10) === 0;
        }*/

        /*if (additionalConstraints.includes('capacity4') || additionalConstraints.includes('capacity5')) {
            reason.reason10 = parseInt(order['toteBoxDry'], 10) === 0 && parseInt(order['toteBoxWet'], 10) === 0;
        }*/


        if (this.$userData.checkReadyToShip) {
          reason.reason11 = !order['readyToShip'] || order['readyToShip'] === false;
        }
      }

      return reason;
    }
  }, {
    key: "formatRoutes",
    value: function formatRoutes(routes) {
      var isCalculateETA = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return routes.map(function (routeData) {
        routeData['startTime'] = isCalculateETA ? routeData['startTime'] : null;
        routeData['estimateTime'] = isCalculateETA ? routeData['estimateTime'] : null;
        return routeData;
      });
    }
  }, {
    key: "getTruckInfo",
    value: function getTruckInfo(truckId) {
      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getTruckInPlan",
    value: function getTruckInPlan(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0.routes', []);
    }
  }, {
    key: "getTruckPlanIdsByTruckId",
    value: function getTruckPlanIdsByTruckId(truckId) {
      var truck = this.getTruckInPlan(truckId);

      if (truckId && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "getWaypointsFromIds",
    value: function getWaypointsFromIds(waypointIds) {
      var _this9 = this;

      var waypoints = [];
      var orderIds = this.helper.uniq(this.helper.map(waypointIds, function (id) {
        return parseInt(id.split('-')[0], 10);
      }));
      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this9.helper.includes(orderIds, parseInt(order['id'], 10));
      });
      this.helper.forEach(filteredOrders, function (order) {
        _this9.helper.forEach(order['waypoints'], function (waypoint) {
          _this9.helper.forEach(waypointIds, function (wpId) {
            if (waypoint['id'] === wpId) {
              waypoints.push(waypoint);
              return false;
            }
          });
        });
      });
      return filteredOrders.length > 0 ? waypoints : [];
    }
  }, {
    key: "getWaypointFromId",
    value: function getWaypointFromId(waypointId, fieldName) {
      var orderId = parseInt(waypointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(waypointId.split('-')[1], 10) || null;

      if (!orderId || !waypointIndex) {
        return null;
      }

      var order = this.$plan['orders'].filter(function (o) {
        return o['id'] === orderId;
      });

      if (!order || order.length === 0) {
        return '';
      }

      var waypoint = this.helper.find(order[0].waypoints, function (wp) {
        return wp.id === waypointId;
      });

      if (!waypoint || waypoint.length === 0) {
        return '';
      }

      return waypoint[fieldName];
    }
  }, {
    key: "getOrderField",
    value: function getOrderField(orderId, fieldName) {
      var selectedOrder = this.helper.get(this.helper.filter(this.$plan['orders'], function (order) {
        return order['id'] === parseInt(orderId, 10);
      }), '0', null);

      if (selectedOrder) {
        return selectedOrder[fieldName];
      }

      return null;
    }
  }, {
    key: "getOrdersField",
    value: function getOrdersField(orderIds, fieldName) {
      var _this10 = this;

      var filteredOrders = this.$plan.orders.filter(function (o) {
        return orderIds.includes(o.id);
      });

      if (this.helper.isUndefined(filteredOrders) || filteredOrders.length === 0) {
        return [];
      }

      return filteredOrders.map(function (o) {
        return o[fieldName];
      }).filter(function (v) {
        return !_this10.helper.isUndefined(v);
      });
    }
  }, {
    key: "adhocAssign",
    value: function () {
      var _adhocAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var isNewTruckObj,
            param,
            payload,
            truckObj,
            tType,
            res,
            message,
            errType,
            errCode,
            response,
            invalidReasons,
            invalidRes,
            _message,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isNewTruckObj = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                param = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                truckObj = this.getTruckInPlan(data['truck']['id']);
                tType = this.helper.get(truckObj, 'type', 'MANUALASSIGN');

                if (isNewTruckObj) {
                  payload = {
                    company: this.$userInformation.company.name,
                    user: this.$userInformation.user.name,
                    code: this.$planDate,
                    startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                    routes: data['orders'],
                    vehicles: [_objectSpread(_objectSpread({}, data['truck']), {}, {
                      type: tType,
                      code: data['truck']['truckId'],
                      zone: data['truck']['zone'],
                      truckCommodityType: data['truck']['truckCommodityType'],
                      plateNumber: data['truck']['plateNumber'],
                      capacity1: parseFloat(data['truck']['weight']),
                      capacity2: parseFloat(data['truck']['volume']),
                      capacity3: parseFloat(data['truck']['assemblyMinutes']),
                      workingHours: data['truck']['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                      driverId: this.$selectedDriver || null,
                      currentDriverId: this.$selectedDriver || null
                    })],
                    planId: data['planId']
                  };
                } else {
                  payload = {
                    company: this.$userInformation.company.name,
                    user: this.$userInformation.user.name,
                    code: this.$planDate,
                    startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                    routes: data['orders'],
                    vehicles: [_objectSpread(_objectSpread({}, data['truck']), {}, {
                      type: tType,
                      currentDriverId: this.helper.get(data, 'truck.driverId.0', null)
                    })],
                    planId: data['planId']
                  };
                }

                _context.next = 7;
                return this.lastMileDeliveryAPI.adhocAssign(payload, _objectSpread(_objectSpread({}, param), {}, {
                  pickUpAllFirst: this.$pickUpAllFirst,
                  timeWindowPriority: this.$timeWindowPriority,
                  timeWindowBuffer: Number(this.$timeWindowBuffer || 1) * 60,
                  adjustETA: this.$adjustETA
                }));

              case 7:
                res = _context.sent;

                if (data['truck'] && res && !res.failed && !this.helper.isUndefined(res.data) && res.data.vehicles.length) {
                  _context.next = 14;
                  break;
                }

                message = {
                  title: this.$t('planning.messages.noSolution'),
                  duration: 5000
                };
                errType = this.helper.get(res, 'data.error', null);

                if (errType === 'no vehicle found') {
                  errCode = this.helper.get(res, 'data.invalidVehicles.0.code', '');
                  message = {
                    title: this.$t("planning.autoAssignInvalidCodes.".concat(errCode)),
                    duration: 5000
                  };
                }

                _elementUi.Notification.error(message);

                return _context.abrupt("return", null);

              case 14:
                response = res.data;
                invalidReasons = [];
                invalidRes = (0, _toConsumableArray2.default)(response['invalid']);

                if (invalidRes.length > 0) {
                  _message = {
                    title: this.$t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  _elementUi.Notification.success(_message); // NOTE: fix grouping logic is on backend


                  invalidReasons = invalidRes.map(function (irData) {
                    return {
                      code: irData['code'] || '',
                      type: irData['type'] || '',
                      reason: irData['reason'] || '',
                      orderId: irData['orderId'] || [],
                      shipmentReference: irData['shipmentReference'] || [],
                      plateNumber: irData['plateNumber'] || [],
                      vehicleId: irData['vehicleId'] || []
                    };
                  });
                }

                return _context.abrupt("return", {
                  invalidReasons: invalidReasons,
                  invalidOrderIds: response['invalidOrder'],
                  vehicles: response.vehicles
                });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function adhocAssign(_x) {
        return _adhocAssign.apply(this, arguments);
      }

      return adhocAssign;
    }()
  }, {
    key: "manualAssign",
    value: function () {
      var _manualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, isTransfer) {
        var truckId, truckInPlan, routes, truckObj, tType, res, invalid, message, errType, errCode, response, invalidReasons, _message2, _message3;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // let cleanRoutes = [];
                truckId = this.helper.get(data, 'truck.id', null);
                truckInPlan = this.getTruckInPlan(truckId);
                routes = this.helper.get(truckInPlan, 'routes', []); // if (routes.length > 0) {
                // 	cleanRoutes = [...routes];
                // }

                truckObj = this.getTruckInPlan(data['truck']['id']);
                tType = this.helper.get(truckObj, 'type', 'MANUALASSIGN');
                _context2.next = 7;
                return this.lastMileDeliveryAPI.manualAssign({
                  status: data['status'] || 'UNASSIGNED',
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                  routes: data['orders'],
                  vehicles: [_objectSpread(_objectSpread({}, data['truck']), {}, {
                    type: tType,
                    code: data['truck']['truckId'],
                    zone: data['truck']['zone'],
                    truckCommodityType: data['truck']['truckCommodityType'],
                    plateNumber: data['truck']['plateNumber'],
                    capacity1: parseFloat(data['truck']['weight']),
                    capacity2: parseFloat(data['truck']['volume']),
                    capacity3: parseFloat(data['truck']['assemblyMinutes']),
                    workingHours: data['truck']['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                    driverId: this.$selectedDriver || null,
                    currentDriverId: this.$selectedDriver || null,
                    overideStartDateTime: data['overideStartDateTime'] || null
                  })],
                  planId: data['planId']
                }, {
                  pickUpAllFirst: this.$pickUpAllFirst,
                  timeWindowPriority: this.$timeWindowPriority,
                  timeWindowBuffer: Number(this.$timeWindowBuffer || 1) * 60,
                  adjustETA: this.$adjustETA
                }, isTransfer);

              case 7:
                res = _context2.sent;
                invalid = (0, _toConsumableArray2.default)(res.data['invalid'] || []);

                if (!(!(data.truck && res && !res.failed && !this.helper.isUndefined(res.data) && res.data.vehicles.length) && invalid.length === 0)) {
                  _context2.next = 15;
                  break;
                }

                message = {
                  title: this.$t('planning.messages.noSolution'),
                  duration: 5000
                };
                errType = this.helper.get(res, 'data.error', null);

                if (errType === 'no vehicle found') {
                  errCode = this.helper.get(res, 'data.invalidVehicles.0.code', '');
                  message = {
                    title: this.$t("planning.autoAssignInvalidCodes.".concat(errCode)),
                    duration: 5000
                  };
                }

                _elementUi.Notification.error(message);

                return _context2.abrupt("return", null);

              case 15:
                response = res.data;
                invalidReasons = [];

                if (invalid.length > 0) {
                  if (!(response.vehicles && response.vehicles.length)) {
                    _message2 = {
                      title: this.$t('planning.messages.failedInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.warning(_message2);
                  } else {
                    _message3 = {
                      title: this.$t('planning.messages.successInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.success(_message3);
                  }

                  invalid.forEach(function (item) {
                    var reason = item['reason'];
                    var type = item['type'];
                    var code = item['code'];

                    if (invalidReasons.filter(function (i) {
                      return i['type'] === type;
                    }).length === 0) {
                      invalidReasons.push({
                        reason: reason,
                        code: code,
                        type: type,
                        orderId: item.orderId || [],
                        shipmentReference: item.shipmentReference || [],
                        vehicleId: item.vehicleId || [],
                        plateNumber: item.plateNumber || []
                      });
                    } else {
                      var index = invalidReasons.findIndex(function (i) {
                        return i['type'] === type;
                      });

                      if (index !== -1) {
                        if (item.orderId) {
                          invalidReasons[index]['orderId'].push(item.orderId);
                        }

                        if (item.shipmentReference) {
                          invalidReasons[index]['shipmentReference'].push(item.shipmentReference);
                        }

                        if (item.vehicleId) {
                          invalidReasons[index]['vehicleId'].push(item.vehicleId);
                        }

                        if (item.plateNumber) {
                          invalidReasons[index]['plateNumber'].push(item.plateNumber);
                        }
                      }
                    }
                  });
                }

                return _context2.abrupt("return", {
                  invalidReasons: invalidReasons,
                  invalidOrderIds: response['invalidOrder'],
                  vehicles: response.vehicles
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function manualAssign(_x2, _x3) {
        return _manualAssign.apply(this, arguments);
      }

      return manualAssign;
    }()
  }, {
    key: "autoAssign",
    value: function () {
      var _autoAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var _this11 = this;

        var isReuseNoZone, isAutoAssignAll, locationType, vehicles, disabledTrucks, res, _orderParams, startTime, endTime, excludeOrders, includeOrders, blockedProjects, orderParams, filters, filterQuery, filterExactQuery, order, orderBy, filterOrder;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isReuseNoZone = data['isReuseNoZone'] || false;
                isAutoAssignAll = data['isAutoAssignAll'] || false; // Insert log

                /*this.insertLogs('auto assign', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     routes: data['orders']
                        ? data['orders'].map((oData) => {
                                return {
                                    shipmentReference: oData['shipmentReference'] || '',
                                    orderId: oData['id'] || '',
                                };
                            })
                        : [],
                    type: this.$locationType,
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/

                locationType = this.$locationType && this.$locationType === 'dropoff' ? 'drop' : 'pick';
                vehicles = [];
                disabledTrucks = [];

                if (window.localStorage.getItem(this.disableTruckKey)) {
                  disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
                }

                this.$trucks.filter(function (truck) {
                  return isReuseNoZone ? truck['hasValidZone'] : truck;
                }).forEach(function (truck) {
                  // TODO: new logic
                  // if (this.isValidTruck(truck) && !this.helper.includes(disabledTrucks, truck['id'].toString())) {
                  // if (!this.helper.includes(disabledTrucks, truck['id'].toString())) {
                  var truckInPlan = _this11.getTruckInPlan(truck['id']);

                  var tType = _this11.helper.get(truckInPlan, 'type', 'AUTOASSIGN');

                  var obj = _objectSpread(_objectSpread({}, truck), {}, {
                    type: tType,
                    code: truck['id'],
                    zone: truck['zone'],
                    truckCommodityType: truck['truckCommodityType'],
                    plateNumber: truck['plateNumber'],
                    capacity1: parseFloat(truck['weight']),
                    capacity2: parseFloat(truck['volume']),
                    capacity3: parseFloat(truck['assemblyMinutes']),
                    workingHours: truck['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                    driverId: truck['drivers'].length > 0 ? truck['drivers'][0]['id'] : null,
                    vehicleIsLocked: false
                  }); // }


                  var hasAssignedCompletedRoutes = false;

                  if (truckInPlan) {
                    hasAssignedCompletedRoutes = _this11.helper.some(truckInPlan['routes'], function (i) {
                      return i['status'] === 'ASSIGNED' || i['status'] === 'COMPLETED';
                    });
                  }

                  if (_this11.helper.includes(disabledTrucks, truck['id'].toString()) || hasAssignedCompletedRoutes) {
                    obj['vehicleIsLocked'] = true;
                    obj['orders'] = [];
                  }

                  vehicles.push(obj);
                });

                if (!(vehicles.length > 0)) {
                  _context3.next = 36;
                  break;
                }

                if (!isAutoAssignAll) {
                  _context3.next = 30;
                  break;
                }

                startTime = this.helper.revertTimezone(this.$store.getters['lastMileV2/startDate'], this.$timezone);
                endTime = this.helper.revertTimezone(this.$store.getters['lastMileV2/endDate'], this.$timezone);
                excludeOrders = this.$store.getters['lastMileV2/excludedOrders'];
                includeOrders = this.$store.getters['lastMileV2/includedOrders'];
                blockedProjects = this.$userInformation['blockedProjects'] || [];
                orderParams = (_orderParams = {
                  modeType: 'lastmile',
                  type: this.$store.getters['lastMileV2/dateRangeOption'],
                  startTime: startTime,
                  endTime: endTime,
                  exactValue: this.$store.getters['lastMileV2/searchType'] === 'exactSearch',
                  order: 'dropBuilding:DESC'
                }, (0, _defineProperty2.default)(_orderParams, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation['customerKey']), (0, _defineProperty2.default)(_orderParams, "userId", this.$userInformation['user']['id']), _orderParams);
                filters = this.$store.getters['lastMileV2/orderFilters'];
                filterQuery = this.helper.getFilterQuery(filters);

                if (!this.helper.isUndefined(filterQuery.queryAnd)) {
                  orderParams['queryAnd'] = filterQuery.queryAnd;
                }

                if (!this.helper.isUndefined(filterQuery.queryOr)) {
                  orderParams['queryOr'] = filterQuery.queryOr;
                }

                filterExactQuery = this.helper.getExactFilterQuery(filters);

                if (filterExactQuery !== '') {
                  orderParams['exactQuery'] = filterExactQuery;
                }

                order = this.$store.getters['lastMileV2/pagination']['order'];
                orderBy = this.$store.getters['lastMileV2/pagination']['orderBy'];
                filterOrder = orderBy !== null && orderBy !== '' ? "".concat(orderBy, ":").concat(order) : '';

                if (filterOrder !== '') {
                  orderParams['order'] = filterOrder;
                }

                _context3.next = 27;
                return this.lastMileDeliveryAPI.autoAssignAll({
                  // for auto assign
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                  routes: data['orders'],
                  vehicles: this.getAvailableVehicles(vehicles),
                  // for order table
                  excludeOrders: excludeOrders,
                  includeOrders: includeOrders,
                  blockedProjects: blockedProjects
                }, _objectSpread({
                  algorithmType: 'AUTOASSIGN',
                  // for auto assign
                  pickUpAllFirst: this.$pickUpAllFirst,
                  timeWindowPriority: this.$timeWindowPriority,
                  timeWindowBuffer: Number(this.$timeWindowBuffer || 1) * 60,
                  adjustETA: this.$adjustETA
                }, orderParams), locationType);

              case 27:
                res = _context3.sent;
                _context3.next = 33;
                break;

              case 30:
                _context3.next = 32;
                return this.lastMileDeliveryAPI.autoAssign({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                  routes: data['orders'],
                  vehicles: this.getAvailableVehicles(vehicles)
                }, {
                  pickUpAllFirst: this.$pickUpAllFirst,
                  timeWindowPriority: this.$timeWindowPriority,
                  timeWindowBuffer: Number(this.$timeWindowBuffer || 1) * 60,
                  adjustETA: this.$adjustETA
                }, locationType);

              case 32:
                res = _context3.sent;

              case 33:
                return _context3.abrupt("return", res.data);

              case 36:
                return _context3.abrupt("return", null);

              case 37:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function autoAssign(_x4) {
        return _autoAssign.apply(this, arguments);
      }

      return autoAssign;
    }()
  }, {
    key: "autoAssignReuseNoZone",
    value: function () {
      var _autoAssignReuseNoZone = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
        var _this12 = this;

        var locationType, vehicles, disabledTrucks, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Insert log

                /*this.insertLogs('auto assign', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     routes: data['orders']
                        ? data['orders'].map((oData) => {
                                return {
                                    shipmentReference: oData['shipmentReference'] || '',
                                    orderId: oData['id'] || '',
                                };
                            })
                        : [],
                    type: this.$locationType,
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/
                locationType = this.$locationType && this.$locationType === 'dropoff' ? 'drop' : 'pick';
                vehicles = [];
                disabledTrucks = [];

                if (window.localStorage.getItem(this.disableTruckKey)) {
                  disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
                }

                this.$trucks.filter(function (truck) {
                  return !truck['hasValidZone'];
                }).forEach(function (truck) {
                  // if (this.isValidTruck(truck) && !this.helper.includes(disabledTrucks, truck['id'].toString())) {
                  if (!_this12.helper.includes(disabledTrucks, truck['id'].toString())) {
                    var truckObj = _this12.getTruckInPlan(truck['id']);

                    var tType = _this12.helper.get(truckObj, 'type', 'AUTOASSIGN');

                    vehicles.push(_objectSpread(_objectSpread({}, truck), {}, {
                      type: tType,
                      code: truck['id'],
                      zone: truck['zone'],
                      truckCommodityType: truck['truckCommodityType'],
                      plateNumber: truck['plateNumber'],
                      capacity1: parseFloat(truck['weight']),
                      capacity2: parseFloat(truck['volume']),
                      capacity3: parseFloat(truck['assemblyMinutes']),
                      workingHours: truck['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                      driverId: truck['drivers'].length > 0 ? truck['drivers'][0]['id'] : null
                    }));
                  }
                });

                if (!(vehicles.length >= 1 && data['orders'].length >= 1)) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 8;
                return this.lastMileDeliveryAPI.autoAssignReuseNoZone({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                  routes: data['orders'],
                  vehicles: this.getAvailableVehicles(vehicles)
                }, {
                  pickUpAllFirst: this.$pickUpAllFirst,
                  timeWindowPriority: this.$timeWindowPriority,
                  timeWindowBuffer: Number(this.$timeWindowBuffer || 1) * 60,
                  adjustETA: this.$adjustETA
                }, locationType);

              case 8:
                res = _context4.sent;
                return _context4.abrupt("return", res.data);

              case 12:
                return _context4.abrupt("return", null);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function autoAssignReuseNoZone(_x5) {
        return _autoAssignReuseNoZone.apply(this, arguments);
      }

      return autoAssignReuseNoZone;
    }()
  }, {
    key: "isValidTruck",
    value: function isValidTruck(truck) {
      if (!truck) {
        return false;
      } // const isTimeWindow: boolean = this.$userSetting.default2;


      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];
      var isMaxOrder = default12.length >= 1 && this.helper.isInArray('maxOrders', default12);
      var maxOrder = 60; // NOTE: add max order

      if (isMaxOrder) {
        maxOrder = Number(truck['maxOrders'] || 60);
      }

      var truckRoutes = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truck['id'];
      }), '0.routes', []);
      var truckPercentage = Number(this.$userSetting.default17 || 70); // if (truckPercentage >= 90) {
      // 	truckPercentage = 90;
      // }

      var srtTime = (truck['workingHours'][0] || process.env.VUE_APP_DEFAULT_START_WORKINGHR).split(':');
      var srtSeconds = +srtTime[0] * 60 * 60 + +srtTime[1] * 60 + +srtTime[2];
      var endTime = (truck['workingHours'][1] || process.env.VUE_APP_DEFAULT_END_WORKINGHR).split(':');
      var endSeconds = +endTime[0] * 60 * 60 + +endTime[1] * 60 + +endTime[2];
      var truckLimit = truckPercentage / 100 * Number(endSeconds - srtSeconds);
      var truckWeight = truckPercentage / 100 * Number(truck['weight']);
      var truckVolume = truckPercentage / 100 * Number(truck['volume']);
      var isValid = false;

      if (truckRoutes.length >= 2) {
        var truckLastRouteCount = this.getRouteNumbers(truckRoutes);

        if (maxOrder > truckLastRouteCount['orderCount'] && truckWeight > Number(truckLastRouteCount['capacity1']) && truckVolume > Number(truckLastRouteCount['capacity2']) && truckLimit > Number(truckLastRouteCount['time']) && endSeconds > Number(truckLastRouteCount['endTime']) && 86400 > truckLastRouteCount['time'] // NOTE: if time is morethan 24 hrs
        ) {
          isValid = true;
        }
      } else {
        isValid = true;
      }

      var hasAssignedCompletedRoute = this.helper.some(truckRoutes, function (i) {
        return i.status.toUpperCase() === 'INTRANSIT' || i.status.toUpperCase() === 'COMPLETED';
      });
      return isValid && parseFloat(truck['weight']) > 0 && parseFloat(truck['volume']) > 0 && !hasAssignedCompletedRoute;
    }
  }, {
    key: "disableInvalidTrucks",
    value: function disableInvalidTrucks() {
      var _this13 = this;

      var disabledTrucks = [];

      if (window.localStorage.getItem(this.disableTruckKey)) {
        disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
      }

      this.$plan.trucks.forEach(function (truck) {
        var truckObj = _this13.getTruckInfo(truck.truckId);

        if (!_this13.isValidTruck(truckObj)) {
          disabledTrucks.push(truck.truckId.toString());
        }
      });
      this.disableTruckList = this.helper.cloneDeep(disabledTrucks);
      localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
      this.logger.info('Disable Invalid Truck and put it on a local storage', this.disableTruckList);
    }
  }, {
    key: "calculateETA",
    value: function () {
      var _calculateETA = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(payload, type) {
        var truckId,
            routes,
            sortedRoutes,
            startTime,
            res,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                truckId = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : this.$selectedTruck;
                routes = this.helper.cloneDeep(payload.routes);
                sortedRoutes = this.helper.cloneDeep(payload.routes).sort(function (a, b) {
                  if (a['startRunningTime'] > b['startRunningTime']) {
                    return 1;
                  }

                  if (b['startRunningTime'] > a['startRunningTime']) {
                    return -1;
                  }

                  return 0;
                });
                startTime = payload.startTime ? payload.startTime : routes[0].startTime;

                if (type === 'REORDER') {
                  startTime = payload.index === 0 ? sortedRoutes[0].estimateTime : routes[payload.index].estimateTime;
                }

                _context5.next = 7;
                return this.lastMileDeliveryAPI.calculateETA({
                  code: this.$planDate,
                  dateTime: startTime,
                  vehicle: [_objectSpread(_objectSpread({}, this.getTruckInPlan(truckId)), {}, {
                    routes: (0, _toConsumableArray2.default)(payload['routes'])
                  })],
                  index: payload.index,
                  locked: payload.isLocked
                }, {
                  pickUpAllFirst: this.$pickUpAllFirst,
                  timeWindowPriority: this.$timeWindowPriority,
                  timeWindowBuffer: Number(this.$timeWindowBuffer || 1) * 60,
                  adjustETA: this.$adjustETA
                });

              case 7:
                res = _context5.sent;

                if (res && !res.failed && !this.helper.isUndefined(res.data)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", null);

              case 10:
                // Insert log

                /*const title = this.helper.isUndefined(type === 'REORDER') ? 'reorder route' : 'update route eta';
                this.insertLogs(title, {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     truckId: this.$selectedTruck,
                    payload,
                    request: {
                        company: this.$userInformation.company.name,
                        code: this.$planDate,
                        startDateTime: startTime,
                        startIndex: payload.index,
                        routes: this.formatRoutes(routes, true),
                        locked: payload.isLocked,
                        deletedOrders: payload.deletedOrders,
                    },
                    response: res.data,
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/
                this.$anyChanges = true;
                return _context5.abrupt("return", res.data);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function calculateETA(_x6, _x7) {
        return _calculateETA.apply(this, arguments);
      }

      return calculateETA;
    }()
  }, {
    key: "updateCurrentTruck",
    value: function updateCurrentTruck(response) {
      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;

      if (truckId && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === truckId;
        });

        if (index !== -1) {
          if (response.vehicles.length === 0) {
            if (plan.hasOwnProperty('truckId')) {
              plan['truckId'] = plan['truckId'].filter(function (tId) {
                return tId !== truckId;
              });
            }

            plan['trucks'].splice(index, 1);
          } else {
            plan['trucks'][index] = _objectSpread(_objectSpread({}, plan['trucks'][index]), this.helper.get(response, 'vehicles.0', {}));
          }
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "isGenerateNewPlanId",
    value: function isGenerateNewPlanId(truckObj) {
      if (!truckObj.hasUpdate) {
        return false;
      }

      if (this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'ASSIGNED';
      }) || this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'COMPLETED';
      })) {
        return false;
      }

      return true;
      /*if (
          this.helper.every(truckObj.routes, (i) => i['status'] === 'UNASSIGNED') &&
          this.helper.every(truckObj.routes, (i) => this.helper.isUndefined(i['planId']))
      ) {
          return true;
      }
       if (
          this.helper.every(truckObj.routes, (i) => i['status'] === 'ASSIGNED') &&
          this.helper.every(truckObj.routes, (i) => this.helper.isUndefined(i['planId']))
      ) {
          return true;
      }
       if (
          this.helper.some(truckObj.routes, (i) => i['status'] === 'ASSIGNED') &&
          this.helper.some(truckObj.routes, (i) => i['status'] === 'UNASSIGNED')
      ) {
          const assignedRoutes = truckObj.routes.filter((r) => r.status === 'ASSIGNED');
          const unassignedRoutes = truckObj.routes.filter((r) => r.status === 'UNASSIGNED');
           return (
              this.helper.every(assignedRoutes, (r) => !this.helper.isUndefined(r.planId)) &&
              this.helper.every(unassignedRoutes, (r) => this.helper.isUndefined(r.planId))
          );
      }
       return false;*/
    }
  }, {
    key: "savePlan",
    value: function () {
      var _savePlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this14 = this;

        var plan,
            isAutoAssign,
            overrideMessage,
            isUpdateSocket,
            isResetPlan,
            truckId,
            tType,
            isPlanNotExist,
            checkDuplicateRes,
            errMsg,
            hasDuplicate,
            duplicateData,
            duplicatedShipRefs,
            duplicatedShipRefOrderIds,
            _errMsg,
            duplicatedVehicleId,
            duplicatedOriginalVehicleId,
            bufferPlan,
            i,
            indexes,
            cancelDriverAssignmentResponse,
            m,
            customId,
            prefix,
            newPlanIds,
            payload,
            message,
            deletePayload,
            deleteRes,
            saveRes,
            _args6 = arguments;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                plan = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : this.$plan;
                isAutoAssign = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                overrideMessage = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
                isUpdateSocket = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : true;
                isResetPlan = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : true;
                truckId = _args6.length > 5 && _args6[5] !== undefined ? _args6[5] : this.$selectedTruck;
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true;
                tType = 'MANUALASSIGN';
                isPlanNotExist = !plan || !plan['trucks'] || !plan['trucks'].length || !plan['planId'].length;

                if (isAutoAssign) {
                  tType = 'AUTOASSIGN';
                  isPlanNotExist = !plan || !plan['trucks'] || !plan['trucks'].length;
                }

                if (!isPlanNotExist) {
                  _context6.next = 19;
                  break;
                }

                if (!(overrideMessage === 'REMOVEORDER')) {
                  _context6.next = 15;
                  break;
                }

                _context6.next = 15;
                return this.deletePlan({
                  isAutoAssign: isAutoAssign
                });

              case 15:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                this.$anyChanges = false;
                return _context6.abrupt("return", false);

              case 19:
                _context6.next = 21;
                return this.lastMileDeliveryAPI.checkDuplicate({
                  userEmail: this.$userInformation.user.name,
                  type: tType,
                  vehicles: plan['trucks']
                });

              case 21:
                checkDuplicateRes = _context6.sent;

                if (checkDuplicateRes && checkDuplicateRes.data) {
                  _context6.next = 29;
                  break;
                }

                errMsg = {
                  title: this.$t('planning.messages.checkDuplicateOrderFailed'),
                  duration: 5000
                };

                _elementUi.Notification.error(errMsg);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                this.$anyChanges = false;
                return _context6.abrupt("return", false);

              case 29:
                hasDuplicate = this.helper.get(checkDuplicateRes, 'data.hasDuplicate', true);

                if (!hasDuplicate) {
                  _context6.next = 63;
                  break;
                }

                duplicateData = this.helper.get(checkDuplicateRes, 'data.waypointId', []);
                duplicatedShipRefs = this.helper.uniq(duplicateData.map(function (data) {
                  return data.shipmentReference;
                }));
                duplicatedShipRefOrderIds = this.helper.uniq(duplicateData.map(function (data) {
                  return data.orderId;
                }));
                _errMsg = {
                  title: this.$t('planning.messages.hasDuplicateOrder') + ': ' + duplicatedShipRefs.join(', '),
                  duration: 10000
                };

                _elementUi.Notification.error(_errMsg);

                this.logger.info('Duplicated Orders', {
                  shipRefs: duplicatedShipRefs,
                  orderIds: duplicatedShipRefOrderIds
                });

                if (!isAutoAssign) {
                  _context6.next = 50;
                  break;
                }

                _context6.next = 40;
                return this.$initPlan();

              case 40:
                this.logger.info('hasDuplicate - Get Unassigned Orders');
                this.$excludedOrders = [];
                _context6.next = 44;
                return this.$getUnassignedOrders();

              case 44:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                this.$anyChanges = false;
                return _context6.abrupt("return", false);

              case 50:
                duplicatedVehicleId = this.helper.uniq(duplicateData.map(function (data) {
                  return data.vehicleId;
                }));
                duplicatedOriginalVehicleId = this.helper.uniq(duplicateData.map(function (data) {
                  return data.originalVehicleId;
                }));

                if (![].concat((0, _toConsumableArray2.default)(duplicatedVehicleId), (0, _toConsumableArray2.default)(duplicatedOriginalVehicleId)).includes(truckId)) {
                  _context6.next = 63;
                  break;
                }

                _context6.next = 55;
                return this.$initPlan();

              case 55:
                this.logger.info('hasDuplicate - Get Unassigned Orders');
                this.$excludedOrders = [];
                _context6.next = 59;
                return this.$getUnassignedOrders();

              case 59:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                this.$anyChanges = false;
                return _context6.abrupt("return", false);

              case 63:
                bufferPlan = this.helper.cloneDeep(plan);
                i = 0;
                indexes = [];

                if (!(this.$toBeUnassignedOrderIds.length > 0)) {
                  _context6.next = 74;
                  break;
                }

                _context6.next = 69;
                return this.cancelDriverAssignment(this.$toBeUnassignedOrderIds);

              case 69:
                cancelDriverAssignmentResponse = _context6.sent;

                if (cancelDriverAssignmentResponse) {
                  _context6.next = 74;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 74:
                if (!this.$isAssignedDriverChanges) {
                  _context6.next = 80;
                  break;
                }

                m = {
                  title: this.$t('planning.messages.assignedDriverChanges'),
                  duration: 5000
                };

                _elementUi.Notification.warning(m);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 80:
                this.helper.forEach(bufferPlan['trucks'], function (truck, index) {
                  var isGenerateNewPlanId = _this14.isGenerateNewPlanId(truck);

                  if (isGenerateNewPlanId) {
                    i++;
                    indexes.push(index);
                  }

                  var lastIdxWithPlanId = _this14.helper.findLastIndex(truck.routes, function (route) {
                    return !_this14.helper.isUndefined(route.planId);
                  });

                  var id = lastIdxWithPlanId !== -1 ? truck.routes[lastIdxWithPlanId].planId : null;
                  truck.estimatedDistance = _this14.getRouteDetails(truck.truckId)['estimatedDistance'];
                  truck.estimatedTime = _this14.getRouteDetails(truck.truckId)['estimatedTime'];

                  _this14.helper.forEach(truck['routes'], function (route) {
                    route.isHighlighted = false;

                    if (lastIdxWithPlanId !== -1 && _this14.helper.isUndefined(route.planId) && !isGenerateNewPlanId) {
                      route.planId = id;
                    }
                  });
                });

                if (!isAutoAssign) {
                  _context6.next = 94;
                  break;
                }

                // WARNING: HARD CODED LOGIC FOR PNS
                customId = this.helper.PNSCustomId(this.$userInformation, plan['orders']); // WARNING: HARD CODED LOGIC FOR PNS

                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile', customId);
                _context6.next = 86;
                return this.routeAPI.generateLoadPlanId(prefix, i);

              case 86:
                newPlanIds = _context6.sent;
                newPlanIds = this.helper.get(newPlanIds, 'data', []);

                if (!(!newPlanIds || newPlanIds.length === 0)) {
                  _context6.next = 93;
                  break;
                }

                _elementUi.Notification.error({
                  title: this.$t('general.planNumberFailed'),
                  duration: 5000
                });

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 93:
                this.helper.forEach(indexes, function (value, index) {
                  var id = newPlanIds[index];
                  bufferPlan.trucks[value].routes.forEach(function (route) {
                    if (_this14.helper.isUndefined(route.planId)) {
                      route.planId = id;
                    }
                  });
                  bufferPlan.trucks[value].planId = _this14.helper.uniq(bufferPlan.trucks[value].routes.map(function (x) {
                    return x['planId'];
                  }));
                });

              case 94:
                bufferPlan['planId'] = this.helper.flatten(bufferPlan['trucks'].map(function (truck) {
                  return truck['planId'];
                }));
                payload = {
                  code: bufferPlan['code'],
                  userEmail: this.$userInformation.user.name,
                  userKey: this.$lfCustKey || null,
                  userToken: this.$lfAPIToken || null,
                  type: isAutoAssign ? 'AUTOASSIGN' : 'MANUALASSIGN',
                  message: overrideMessage ? overrideMessage : null,
                  data: bufferPlan['trucks'].map(function (tData) {
                    delete tData['drivers'];
                    delete tData['orders'];
                    delete tData['trucks'];
                    tData['routes'].map(function (routeData) {
                      delete routeData['orders'];
                      delete routeData['masterpoints'];
                      delete routeData['waypoints'];
                      return routeData;
                    });
                    return tData;
                  }).filter(function (ia) {
                    return ia.truckId === truckId || ia.hasUpdate;
                  })
                };
                message = {
                  title: this.$t('general.updateSuccess'),
                  duration: 5000
                }; // For transfer plan when trucks become empty - optional

                if (!(this.$removedTruckIds.length >= 1)) {
                  _context6.next = 109;
                  break;
                }

                deletePayload = {
                  userEmail: this.$userInformation.user.name,
                  userKey: this.$lfCustKey || null,
                  userToken: this.$lfAPIToken || null,
                  code: this.$plan['code'],
                  truckId: this.$removedTruckIds.toString(),
                  vehicleId: this.$removedTruckIds
                };
                deleteRes = null;

                if (!(this.$removedTruckIds.length === 1)) {
                  _context6.next = 106;
                  break;
                }

                _context6.next = 103;
                return this.lastMileDeliveryAPI.deletePlan({
                  payload: deletePayload,
                  requestParams: {
                    code: this.$plan['code'],
                    vehicleId: deletePayload['truckId']
                  }
                });

              case 103:
                deleteRes = _context6.sent;
                _context6.next = 109;
                break;

              case 106:
                _context6.next = 108;
                return this.lastMileDeliveryAPI.deletePlanAll({
                  payload: _objectSpread(_objectSpread({}, deletePayload), {}, {
                    blockedTrucks: this.$userInformation['blockedTrucks'] || []
                  }),
                  requestParams: {
                    code: this.$plan['code']
                  }
                });

              case 108:
                deleteRes = _context6.sent;

              case 109:
                _context6.next = 111;
                return this.lastMileDeliveryAPI.insertPlan(payload);

              case 111:
                saveRes = _context6.sent;

                if (saveRes && saveRes.data) {
                  _context6.next = 118;
                  break;
                }

                message['title'] = this.$t('general.updateFailed');

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 118:
                if (isUpdateSocket) {
                  // Socket for global plan
                  this.socketAPI.updateLMDGlobalPlan({
                    userEmail: this.$userInformation.user.name,
                    socketId: this.$socketId,
                    code: this.$planDate
                  }); // Socket for global orders

                  this.socketAPI.updateLMDGlobalSelectedOrders({
                    userEmail: this.$userInformation.user.name,
                    socketId: this.$socketId,
                    orderId: [],
                    dataType: 'removeAll'
                  });
                }

                bufferPlan.trucks.forEach(function (truck) {
                  truck.hasUpdate = false;
                });
                this.$setPlan({
                  plan: bufferPlan
                }); // this.$failedOrders = [];

                if (!isResetPlan) {
                  _context6.next = 124;
                  break;
                }

                _context6.next = 124;
                return this.$resetPlan();

              case 124:
                this.$anyChanges = false;
                this.$isPlanExists = true;
                this.$removedTruckIds = [];

                _elementUi.Notification.success(message); // double called when manual assign + auto save
                // if (!isAutoAssign) {


                this.logger.info('Save Plan - Get Unassigned Orders');
                _context6.next = 131;
                return this.$getUnassignedOrders();

              case 131:
                // }
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false; // Insert log

                /*this.insertLogs('save plan', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     planIds: [...bufferPlan.planId],
                    trucks:
                        bufferPlan && bufferPlan.trucks.length
                            ? bufferPlan.trucks.map((truck) => ({
                                    truckId: truck.truckId,
                                    plateNumber: truck.plateNumber,
                                    driverIds: truck.driverId,
                                }))
                            : [],
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/

                return _context6.abrupt("return", true);

              case 134:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function savePlan() {
        return _savePlan.apply(this, arguments);
      }

      return savePlan;
    }()
  }, {
    key: "deleteRoutesInTruck",
    value: function () {
      var _deleteRoutesInTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref) {
        var _ref$isAutoAssign, isAutoAssign, _ref$planId, planId, shipRefFromOrder, deletePayload, requestParams, deleteRes, message;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _ref$isAutoAssign = _ref.isAutoAssign, isAutoAssign = _ref$isAutoAssign === void 0 ? false : _ref$isAutoAssign, _ref$planId = _ref.planId, planId = _ref$planId === void 0 ? null : _ref$planId;
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true; // let isSomeOrdersAssigned = false;

                shipRefFromOrder = this.getShipRefsFromOrders();

                if (!(shipRefFromOrder.length === 0)) {
                  _context7.next = 8;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 8:
                if (!(this.$plan && this.$plan.trucks && this.$plan.trucks.length >= 1)) {
                  _context7.next = 13;
                  break;
                }

                if (this.currTruck) {
                  _context7.next = 13;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 13:
                if (!(this.$includedOrders.length >= 1)) {
                  _context7.next = 16;
                  break;
                }

                _context7.next = 16;
                return this.savePlan(this.$plan, false, 'DELETE', false, true);

              case 16:
                deletePayload = {
                  userEmail: this.$userInformation.user.name,
                  userKey: this.$lfCustKey || null,
                  userToken: this.$lfAPIToken || null,
                  type: isAutoAssign ? 'AUTOASSIGN' : 'MANUALASSIGN',
                  code: this.$plan['code'],
                  truckId: this.$selectedTruck
                };
                requestParams = {
                  code: this.$plan['code'],
                  vehicleId: deletePayload['truckId']
                };

                if (!this.helper.isUndefined(planId)) {
                  requestParams['planId'] = planId;
                }

                _context7.next = 21;
                return this.lastMileDeliveryAPI.deletePlan({
                  payload: deletePayload,
                  requestParams: requestParams
                });

              case 21:
                deleteRes = _context7.sent;
                message = {
                  title: this.$t('general.deleteFailed'),
                  duration: 5000
                };

                if (!(!deleteRes || deleteRes.failed)) {
                  _context7.next = 28;
                  break;
                }

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 28:
                message['title'] = this.$t('general.deleteSuccess');

                _elementUi.Notification.success(message); // Socket for global plan


                this.socketAPI.updateLMDGlobalPlan({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  code: this.$planDate
                }); // Socket for global orders

                this.socketAPI.updateLMDGlobalSelectedOrders({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  orderId: [],
                  dataType: 'removeAll'
                });
                this.$anyChanges = false; // NOTE: clear exclude and include orders

                this.$excludedOrders = [];
                this.$includedOrders = [];
                _context7.next = 37;
                return this.$initPlan();

              case 37:
                this.logger.info('deleteRoutesInTruck - Get Unassigned Orders');
                _context7.next = 40;
                return this.$getUnassignedOrders();

              case 40:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false; // Insert log

                /*this.insertLogs('delete routes in truck', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     truckId: this.$selectedTruck,
                    truck: this.getTruckInfo(this.$selectedTruck),
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/

                return _context7.abrupt("return", true);

              case 43:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteRoutesInTruck(_x8) {
        return _deleteRoutesInTruck.apply(this, arguments);
      }

      return deleteRoutesInTruck;
    }()
  }, {
    key: "deletePlan",
    value: function () {
      var _deletePlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref2) {
        var _ref2$isAutoAssign, isAutoAssign, requestParams, deletePayload, res, message;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _ref2$isAutoAssign = _ref2.isAutoAssign, isAutoAssign = _ref2$isAutoAssign === void 0 ? false : _ref2$isAutoAssign;
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true;
                requestParams = {};
                deletePayload = {
                  userEmail: this.$userInformation.user.name,
                  userKey: this.$lfCustKey || null,
                  userToken: this.$lfAPIToken || null,
                  code: this.$planDate,
                  type: isAutoAssign ? 'AUTOASSIGN' : 'MANUALASSIGN'
                };
                _context8.next = 7;
                return this.lastMileDeliveryAPI.deletePlanAll({
                  payload: _objectSpread(_objectSpread({}, deletePayload), {}, {
                    blockedTrucks: this.$userInformation['blockedTrucks'] || []
                  }),
                  requestParams: requestParams
                });

              case 7:
                res = _context8.sent;
                message = {
                  title: this.$t('general.deleteFailed'),
                  duration: 5000
                };

                if (!(!res || res.failed)) {
                  _context8.next = 14;
                  break;
                }

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context8.abrupt("return", false);

              case 14:
                message['title'] = this.$t('general.deleteSuccess');

                _elementUi.Notification.success(message); // Socket for global plan


                this.socketAPI.updateLMDGlobalPlan({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  code: this.$planDate
                }); // Socket for global orders

                this.socketAPI.updateLMDGlobalSelectedOrders({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  orderId: [],
                  dataType: 'removeAll'
                });
                this.$anyChanges = false; // NOTE: clear exclude and include orders

                this.$excludedOrders = [];
                this.$includedOrders = [];
                _context8.next = 23;
                return this.$initPlan();

              case 23:
                this.logger.info('deleteRoutesInTruck - Get Unassigned Orders');
                _context8.next = 26;
                return this.$getUnassignedOrders();

              case 26:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;

              case 28:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deletePlan(_x9) {
        return _deletePlan.apply(this, arguments);
      }

      return deletePlan;
    }()
  }, {
    key: "getCarPlateFromDriverId",
    value: function getCarPlateFromDriverId(driverId) {
      var driver = this.helper.find(this.$drivers, function (item) {
        return item['RecId'] === driverId;
      });

      if (!this.helper.isUndefined(driver)) {
        return driver['Carplate'];
      }

      return null;
    }
  }, {
    key: "getShipRefsFromOrderId",
    value: function getShipRefsFromOrderId(orderId) {
      var _this15 = this;

      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this15.helper.includes(orderId, parseInt(order['id'], 10));
      });

      if (filteredOrders.length) {
        return this.helper.map(filteredOrders, 'shipmentReference');
      }

      return [];
    }
  }, {
    key: "getShipRefsFromOrders",
    value: function getShipRefsFromOrders() {
      var _this16 = this;

      var selectedTruck = this.helper.find(this.$plan.trucks, function (truck) {
        return truck['truckId'] === _this16.$selectedTruck;
      });

      if (selectedTruck) {
        return selectedTruck['shipmentReference'];
      }

      return [];
    }
  }, {
    key: "confirmUnsavedChanges",
    value: function confirmUnsavedChanges(to, from, next) {
      var _this17 = this;

      if (this.$anyChanges && to.name !== 'login') {
        var message = this.$t('planning.messages.unsavedChanges');

        _elementUi.MessageBox.confirm(message, 'Warning', {
          confirmButtonText: this.$t('pickColumns.confirm'),
          cancelButtonText: this.$t('pickColumns.cancel'),
          type: 'warning',
          center: true
        }).then(function () {
          _this17.$anyChanges = false;

          _this17.$resetPlan();

          next();
        }).catch(function () {
          next(false);
        });
      } else {
        this.$resetPlan(false);
        next();
      }
    }
  }, {
    key: "assignDriver",
    value: function () {
      var _assignDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(payload) {
        var _this18 = this;

        var res, status, response, iOrders;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                payload.forEach(function (payloadData) {
                  payloadData['handledate'] = _this18.$planDate;
                });
                _context9.next = 3;
                return this.planAPI.assignDriver(payload);

              case 3:
                res = _context9.sent;
                status = this.helper.get(res, 'data.status', 300);
                response = {
                  isSuccess: false,
                  invalidOrders: null
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context9.next = 10;
                  break;
                }

                iOrders = this.helper.get(res, 'data.errors', []);
                response['invalidOrders'] = iOrders.length ? this.helper.map(iOrders, 'shipref').join(', ') : '-';
                return _context9.abrupt("return", response);

              case 10:
                response['isSuccess'] = true;
                return _context9.abrupt("return", response);

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function assignDriver(_x10) {
        return _assignDriver.apply(this, arguments);
      }

      return assignDriver;
    }()
  }, {
    key: "cancelDriverAssignment",
    value: function () {
      var _cancelDriverAssignment = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(payload) {
        var res, status, error, message;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.planAPI.cancelDriverAssignment(payload);

              case 2:
                res = _context10.sent;
                status = this.helper.get(res, 'data.status', 300);
                error = null;
                message = {
                  title: this.$t('planning.messages.cancelOrdersAssignmentSuccess'),
                  duration: 5000
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context10.next = 11;
                  break;
                }

                error = this.helper.get(res, 'data.error', null);
                message['message'] = "".concat(this.$t('planning.messages.cancelOrdersAssignmentFailed'), " ").concat(this.$t('planning.messages.dueTo'), " ").concat(error);

                _elementUi.Notification.error(message);

                return _context10.abrupt("return", false);

              case 11:
                _elementUi.Notification.success(message);

                return _context10.abrupt("return", true);

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function cancelDriverAssignment(_x11) {
        return _cancelDriverAssignment.apply(this, arguments);
      }

      return cancelDriverAssignment;
    }()
  }, {
    key: "getStatusColor",
    value: function getStatusColor(route) {
      var cssClass = {
        'pick-up': route['waypointType'] === 'P',
        unassigned: false,
        assigned: false,
        'partial-completed': false,
        completed: false
      };
      var status = route['status'];

      if (route['status'] === 'COMPLETED') {
        if (!route['completepointId'] || route['completepointId'].length !== route['waypointId'].length) {
          status = 'PARTIAL-COMPLETED';
        }
      }

      cssClass[status] = true;
      return cssClass;
    }
  }, {
    key: "isRouteBelongToDifferentUser",
    value: function isRouteBelongToDifferentUser(route) {
      var isAllowEditOtherUserData = this.$userData.updateUserData || false;

      if (isAllowEditOtherUserData) {
        return false;
      }

      if (!route.hasOwnProperty('user')) {
        return false;
      }

      if (route.hasOwnProperty('user') && this.$userInformation && this.$userInformation.user) {
        return route['user'] !== this.$userInformation.user.name;
      }

      return false;
    }
  }, {
    key: "isPlanIdBelongToDifferentUser",
    value: function isPlanIdBelongToDifferentUser(planId) {
      var _this19 = this;

      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var isAllowEditOtherUserData = this.$userData.updateUserData || false;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && _this19.isRouteBelongToDifferentUser(route);
        }) && !isAllowEditOtherUserData;
      }

      return false;
    }
  }, {
    key: "createNewPlanIdRoutes",
    value: function () {
      var _createNewPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref3) {
        var _this20 = this;

        var planId, startTime, truckId, unassignedOrders, isTransfer, isShowFailedOrders, failedOrders, orders, orderIds, message, truckObj, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                planId = _ref3.planId, startTime = _ref3.startTime, truckId = _ref3.truckId, unassignedOrders = _ref3.unassignedOrders, isTransfer = _ref3.isTransfer;
                isShowFailedOrders = false;
                failedOrders = [];
                orders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this20.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                orderIds = this.helper.uniq(this.helper.map(orders, 'id'));

                if (!(orders.length === 0)) {
                  _context11.next = 9;
                  break;
                }

                message = {
                  title: this.$t('planning.messages.cannotAssignEmptyOrder'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context11.abrupt("return", null);

              case 9:
                truckObj = this.getTruckInPlan(truckId); // let overideStartDateTime = null;
                // if (truckObj && truckObj['routes'] && truckObj['routes'].length >= 1) {
                // 	overideStartDateTime = truckObj['routes'][truckObj['routes'].length - 1]['endTime'] || null;
                // }

                _context11.next = 12;
                return this.manualAssign({
                  orders: orders,
                  // overideStartDateTime: overideStartDateTime || null, // NOTE: move the logic to the back-end
                  startTime: this.helper.isUndefined(startTime) ? this.$defaultTime : startTime,
                  truck: _objectSpread({
                    routes: this.helper.get(truckObj, 'routes', [])
                  }, this.getTruckInfo(truckId)),
                  planId: planId
                }, isTransfer);

              case 12:
                res = _context11.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context11.next = 18;
                  break;
                }

                return _context11.abrupt("return", null);

              case 18:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context11.next = 22;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context11.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 22:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context11.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: orderIds
                });

              case 24:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createNewPlanIdRoutes(_x12) {
        return _createNewPlanIdRoutes.apply(this, arguments);
      }

      return createNewPlanIdRoutes;
    }()
  }, {
    key: "updateExistingPlanIdRoutes",
    value: function () {
      var _updateExistingPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref4) {
        var _this21 = this;

        var planId, startTime, truckObj, unassignedOrders, isTransfer, isShowFailedOrders, failedOrders, selectedOrders, selectedOrderIds, currentOrderIds, orderIds, orders, param, firstRouteStatus, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                planId = _ref4.planId, startTime = _ref4.startTime, truckObj = _ref4.truckObj, unassignedOrders = _ref4.unassignedOrders, isTransfer = _ref4.isTransfer;
                isShowFailedOrders = false;
                failedOrders = [];
                selectedOrders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this21.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                selectedOrderIds = this.helper.map(selectedOrders, 'id');
                currentOrderIds = this.helper.uniq(this.helper.flatten(truckObj['routes'].filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route['orderId'];
                })));
                orderIds = this.helper.uniq([].concat((0, _toConsumableArray2.default)(currentOrderIds), (0, _toConsumableArray2.default)(selectedOrderIds))); // NOTE: move the logic to the back-end
                // const existingOrders = this.$plan.orders.filter((order) => this.helper.includes(orderIds, order.id));
                // const orders = this.helper.uniqBy([...existingOrders, ...selectedOrders], (i) => i.id);

                orders = (0, _toConsumableArray2.default)(selectedOrders);
                param = {
                  orders: orders,
                  // overideStartDateTime: null,
                  startTime: this.helper.isUndefined(startTime) ? this.$defaultTime : startTime,
                  truck: _objectSpread({
                    routes: this.helper.get(truckObj, 'routes', [])
                  }, this.getTruckInfo(truckObj['truckId'])),
                  planId: planId
                }; // const firstRouteStatus = this.helper.get(truckObj, 'routes.0.status', 'UNASSIGNED');

                firstRouteStatus = truckObj.routes.find(function (tData) {
                  return tData['status'].toUpperCase() === 'ASSIGNED' && tData['planId'] === planId;
                });

                if (firstRouteStatus) {
                  param['status'] = 'ASSIGNED';
                }

                _context12.next = 13;
                return this.manualAssign(param, isTransfer);

              case 13:
                res = _context12.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context12.next = 19;
                  break;
                }

                return _context12.abrupt("return", null);

              case 19:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context12.next = 23;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context12.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 23:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context12.abrupt("return", {
                  vehicles: vehicles,
                  orders: selectedOrders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: selectedOrderIds
                });

              case 25:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function updateExistingPlanIdRoutes(_x13) {
        return _updateExistingPlanIdRoutes.apply(this, arguments);
      }

      return updateExistingPlanIdRoutes;
    }()
  }, {
    key: "adHocV2NewPlanIdRoutes",
    value: function () {
      var _adHocV2NewPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(_ref5) {
        var _this22 = this;

        var planId, startTime, truckId, unassignedOrders, isShowFailedOrders, failedOrders, orders, orderIds, message, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                planId = _ref5.planId, startTime = _ref5.startTime, truckId = _ref5.truckId, unassignedOrders = _ref5.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                orders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this22.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                orderIds = this.helper.uniq(this.helper.map(orders, 'id'));

                if (!(orders.length === 0)) {
                  _context13.next = 9;
                  break;
                }

                message = {
                  title: this.$t('planning.messages.cannotAssignEmptyOrder'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context13.abrupt("return", null);

              case 9:
                _context13.next = 11;
                return this.adhocAssign({
                  orders: orders,
                  startTime: this.helper.isUndefined(startTime) ? this.$defaultTime : startTime,
                  truck: this.getTruckInfo(truckId),
                  planId: [planId]
                }, true);

              case 11:
                res = _context13.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context13.next = 17;
                  break;
                }

                return _context13.abrupt("return", null);

              case 17:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context13.next = 21;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context13.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 21:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context13.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: orderIds
                });

              case 23:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function adHocV2NewPlanIdRoutes(_x14) {
        return _adHocV2NewPlanIdRoutes.apply(this, arguments);
      }

      return adHocV2NewPlanIdRoutes;
    }()
  }, {
    key: "adHocV2ExistingPlanIdRoutes",
    value: function () {
      var _adHocV2ExistingPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(_ref6) {
        var _this23 = this;

        var planId, startTime, truckObj, unassignedOrders, isShowFailedOrders, failedOrders, selectedOrders, selectedOrderIds, currentOrderIds, orderIds, existingOrders, orders, param, firstRouteStatus, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                planId = _ref6.planId, startTime = _ref6.startTime, truckObj = _ref6.truckObj, unassignedOrders = _ref6.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                selectedOrders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this23.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                selectedOrderIds = this.helper.map(selectedOrders, 'id');
                currentOrderIds = this.helper.uniq(this.helper.flatten(truckObj['routes'].filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route['orderId'];
                })));
                orderIds = this.helper.uniq([].concat((0, _toConsumableArray2.default)(currentOrderIds), (0, _toConsumableArray2.default)(selectedOrderIds)));
                existingOrders = this.$plan.orders.filter(function (order) {
                  return _this23.helper.includes(orderIds, order.id);
                });
                orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(existingOrders), (0, _toConsumableArray2.default)(selectedOrders)), function (i) {
                  return i.id;
                });
                param = {};
                firstRouteStatus = this.helper.get(truckObj, 'routes.0.status', 'UNASSIGNED');

                if (firstRouteStatus === 'ASSIGNED') {
                  param['status'] = 'ASSIGNED';
                }

                _context14.next = 14;
                return this.adhocAssign({
                  orders: selectedOrders,
                  startTime: startTime,
                  truck: truckObj,
                  planId: planId
                }, false, param);

              case 14:
                res = _context14.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context14.next = 20;
                  break;
                }

                return _context14.abrupt("return", null);

              case 20:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context14.next = 24;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context14.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 24:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context14.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: selectedOrderIds
                });

              case 26:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function adHocV2ExistingPlanIdRoutes(_x15) {
        return _adHocV2ExistingPlanIdRoutes.apply(this, arguments);
      }

      return adHocV2ExistingPlanIdRoutes;
    }()
  }, {
    key: "handleNewTruckObj",
    value: function () {
      var _handleNewTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(args) {
        var _this24 = this;

        var planId, startTime, truckId, unassignedOrders, isTransfer, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                planId = args.planId;
                startTime = args.startTime || this.$defaultTime;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                isTransfer = this.helper.get(args, 'isTransfer', false);
                _context15.next = 7;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 7:
                res = _context15.sent;

                if (!this.helper.isUndefined(res)) {
                  _context15.next = 10;
                  break;
                }

                return _context15.abrupt("return");

              case 10:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context15.next = 13;
                  break;
                }

                return _context15.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 13:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this24.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');
                plan.planId = [].concat((0, _toConsumableArray2.default)(this.helper.flatten(plan.trucks.map(function (i) {
                  return i['planId'];
                }))), [planId]);
                plan.trucks.push(truck);
                this.$setPlan({
                  plan: plan
                });
                _context15.next = 21;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 21:
                this.logger.info('Init Truck: ', truck, 'Plan: ', plan);
                return _context15.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 23:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function handleNewTruckObj(_x16) {
        return _handleNewTruckObj.apply(this, arguments);
      }

      return handleNewTruckObj;
    }()
  }, {
    key: "handleExistingTruckObj",
    value: function () {
      var _handleExistingTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(args) {
        var _this25 = this;

        var planId, isNewPlanId, truckObj, unassignedOrders, isTransfer, truckIndex, startTime, res, isShowFailedOrders, failedOrders, truck, plan, firstRouteStatus, isAssignDriver, payload, oIds, orderShipRefs, currentDriver, carPlate;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                planId = args.planId;
                isNewPlanId = args.isNewPlanId || false;
                truckObj = args.truckObj || null;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                isTransfer = this.helper.get(args, 'isTransfer', false);
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (t) {
                  return t['truckId'] === truckObj['truckId'];
                });
                startTime = this.routes[this.routes.length - 1]['endTime'];

                if (!isNewPlanId) {
                  _context16.next = 13;
                  break;
                }

                _context16.next = 10;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  // startTime, // NOTE: move the logic to the back-end
                  startTime: this.$defaultTime,
                  truckId: truckObj['truckId'],
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 10:
                _context16.t0 = _context16.sent;
                _context16.next = 16;
                break;

              case 13:
                _context16.next = 15;
                return this.updateExistingPlanIdRoutes({
                  planId: planId,
                  startTime: this.$defaultTime,
                  truckObj: truckObj,
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 15:
                _context16.t0 = _context16.sent;

              case 16:
                res = _context16.t0;

                if (!this.helper.isUndefined(res)) {
                  _context16.next = 19;
                  break;
                }

                return _context16.abrupt("return");

              case 19:
                isShowFailedOrders = res.isShowFailedOrders;
                failedOrders = res.failedOrders;
                truck = null;

                if (!(this.helper.isUndefined(res['vehicles']) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context16.next = 24;
                  break;
                }

                return _context16.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 24:
                if (isNewPlanId) {
                  truck = _objectSpread({}, res['vehicles']);
                } else {
                  truck = res['vehicles'];
                }

                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(res['orders'])).filter(function (order) {
                  return !_this25.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');

                if (isNewPlanId) {
                  plan.planId = [].concat((0, _toConsumableArray2.default)(this.helper.flatten(plan.trucks.map(function (i) {
                    return i['planId'];
                  }))), [planId]);
                }

                plan.trucks[truckIndex] = truck;
                this.$setPlan({
                  plan: plan
                });
                /**
                 * Assume auto assign to the driver
                 * If not move this to savePlan
                 * */
                // const firstRouteStatus = this.helper.get(truck, 'routes.0.status', 'UNASSIGNED');

                firstRouteStatus = truck.routes.find(function (tData) {
                  return tData['status'].toUpperCase() === 'ASSIGNED' && tData['planId'] === planId;
                });
                isAssignDriver = firstRouteStatus && !isShowFailedOrders && failedOrders.length === 0;
                payload = [];

                if (!isAssignDriver) {
                  _context16.next = 41;
                  break;
                }

                // const oIds = this.helper.get(truck, 'orderId', []);
                oIds = this.helper.uniq(this.helper.flatten(truck.routes.filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route.orderId;
                })));
                orderShipRefs = this.getShipRefsFromOrderId(oIds);
                currentDriver = this.helper.get(truck, 'routes.0.driverId', 'UNASSIGNED');
                carPlate = this.getCarPlateFromDriverId(currentDriver);

                if (!(this.helper.isUndefined(carPlate) || orderShipRefs.length === 0)) {
                  _context16.next = 40;
                  break;
                }

                return _context16.abrupt("return");

              case 40:
                orderShipRefs.forEach(function (order) {
                  payload.push({
                    shipref: order,
                    drivercode: carPlate,
                    truckrecid: plan.trucks[truckIndex].truckId
                  });
                });

              case 41:
                _context16.next = 43;
                return this.updateOrderTable(res['orderIds'], res['invalidOrderIds'], res['selectedOrderIds']);

              case 43:
                this.logger.info('Update Truck: ', truck, 'Plan: ', plan);
                return _context16.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  isAssignDriver: isAssignDriver,
                  assignDriverPayload: payload
                });

              case 45:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function handleExistingTruckObj(_x17) {
        return _handleExistingTruckObj.apply(this, arguments);
      }

      return handleExistingTruckObj;
    }()
  }, {
    key: "handleAdhocV2NewTruckObj",
    value: function () {
      var _handleAdhocV2NewTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(args) {
        var _this26 = this;

        var planId, startTime, truckId, unassignedOrders, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                planId = args.planId;
                startTime = args.startTime || this.$defaultTime;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                _context17.next = 6;
                return this.adHocV2NewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders
                });

              case 6:
                res = _context17.sent;

                if (!this.helper.isUndefined(res)) {
                  _context17.next = 9;
                  break;
                }

                return _context17.abrupt("return");

              case 9:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context17.next = 12;
                  break;
                }

                return _context17.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 12:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this26.helper.includes(invalidOrderIds, order.id);
                }), 'id');
                plan.planId = [].concat((0, _toConsumableArray2.default)(this.helper.flatten(plan.trucks.map(function (i) {
                  return i['planId'];
                }))), [planId]);
                plan.trucks.push(truck);
                this.$setPlan({
                  plan: plan
                });
                _context17.next = 20;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 20:
                this.logger.info('Init Truck with completed order(s): ', truck, 'Plan: ', plan);
                return _context17.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 22:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function handleAdhocV2NewTruckObj(_x18) {
        return _handleAdhocV2NewTruckObj.apply(this, arguments);
      }

      return handleAdhocV2NewTruckObj;
    }()
  }, {
    key: "handleAdhocV2ExistingTruckObj",
    value: function () {
      var _handleAdhocV2ExistingTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(args) {
        var _this27 = this;

        var planId, truckObj, unassignedOrders, truckIndex, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan, firstRouteStatus, isAssignDriver, payload, oIds, orderShipRefs, currentDriver, carPlate;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                planId = args.planId;
                truckObj = args.truckObj || null;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (t) {
                  return t['truckId'] === truckObj['truckId'];
                });
                _context18.next = 6;
                return this.adHocV2ExistingPlanIdRoutes({
                  planId: planId,
                  startTime: this.$defaultTime,
                  truckObj: truckObj,
                  unassignedOrders: unassignedOrders
                });

              case 6:
                res = _context18.sent;

                if (!this.helper.isUndefined(res)) {
                  _context18.next = 9;
                  break;
                }

                return _context18.abrupt("return");

              case 9:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context18.next = 12;
                  break;
                }

                return _context18.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 12:
                truck = _objectSpread({}, vehicles);
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this27.helper.includes(invalidOrderIds, order.id);
                }), 'id');
                plan.trucks[truckIndex] = truck;
                this.$setPlan({
                  plan: plan
                });
                /**
                 * Assume auto assign to the driver
                 * If not move this to savePlan
                 * */

                firstRouteStatus = this.helper.get(truck, 'routes.0.status', 'UNASSIGNED');
                isAssignDriver = firstRouteStatus === 'ASSIGNED' && !isShowFailedOrders && failedOrders.length === 0;
                payload = [];

                if (!isAssignDriver) {
                  _context18.next = 28;
                  break;
                }

                oIds = this.helper.get(truck, 'orderId', []);
                orderShipRefs = this.getShipRefsFromOrderId(oIds);
                currentDriver = this.helper.get(truck, 'routes.0.driverId', 'UNASSIGNED');
                carPlate = this.getCarPlateFromDriverId(currentDriver);

                if (!(this.helper.isUndefined(carPlate) || orderShipRefs.length === 0)) {
                  _context18.next = 27;
                  break;
                }

                return _context18.abrupt("return");

              case 27:
                orderShipRefs.forEach(function (order) {
                  payload.push({
                    shipref: order,
                    drivercode: carPlate,
                    truckrecid: plan.trucks[truckIndex].truckId
                  });
                });

              case 28:
                _context18.next = 30;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 30:
                this.logger.info('Update Truck with completed orders: ', truck, 'Plan: ', plan);
                return _context18.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  isAssignDriver: isAssignDriver,
                  assignDriverPayload: payload
                });

              case 32:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function handleAdhocV2ExistingTruckObj(_x19) {
        return _handleAdhocV2ExistingTruckObj.apply(this, arguments);
      }

      return handleAdhocV2ExistingTruckObj;
    }()
  }, {
    key: "updateOrderTable",
    value: function () {
      var _updateOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(orderIds, invalidOrderIds, selectedOrderIds) {
        var _this28 = this;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.$selectedOrders = [];
                this.$excludedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$excludedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return !_this28.helper.includes(invalidOrderIds, oId);
                }))));
                this.$includedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return _this28.helper.includes(invalidOrderIds, oId);
                }))).filter(function (oId) {
                  return !_this28.helper.includes(selectedOrderIds, oId);
                }));
                this.logger.info('updateOrderTable - Get Unassigned Orders');
                _context19.next = 6;
                return this.$getUnassignedOrders();

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function updateOrderTable(_x20, _x21, _x22) {
        return _updateOrderTable.apply(this, arguments);
      }

      return updateOrderTable;
    }()
  }, {
    key: "getRouteDetails",
    value: function getRouteDetails(truckId) {
      var truck = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truckId;
      }), '0', null);

      if (!truck) {
        return {
          estimatedDistance: 0,
          estimatedTime: 0,
          estimatedReturnDistance: 0,
          estimatedReturnTime: 0
        };
      }

      return {
        estimatedDistance: truck['estimatedDistance'] || 0,
        estimatedTime: truck['estimatedTime'] || 0,
        estimatedReturnDistance: truck['estimatedReturnDistance'] || 0,
        estimatedReturnTime: truck['estimatedReturnTime'] || 0
      };
    }
  }, {
    key: "isOrderIdExistInGlobal",
    value: function isOrderIdExistInGlobal(orderId) {
      var _this29 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this29.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalOrderInfo",
    value: function getGlobalOrderInfo(orderId, fieldName) {
      var _this30 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this30.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }, {
    key: "isTruckIdExistInGlobal",
    value: function isTruckIdExistInGlobal(truckId) {
      var _this31 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this31.$userInformation && _this31.$userInformation.user && o.userId !== _this31.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalTruckInfo",
    value: function getGlobalTruckInfo(truckId, fieldName) {
      var _this32 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this32.$userInformation && _this32.$userInformation.user && o.userId !== _this32.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }, {
    key: "isPlanSyncWithGlobal",
    value: function isPlanSyncWithGlobal(data) {
      return data['socketId'] !== this.$socketId;
    }
  }, {
    key: "updatePlanFromSocket",
    value: function () {
      var _updatePlanFromSocket = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(data) {
        var _this33 = this;

        var globalPlan, bufferPlan, myTruck, orders, trucks;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.$truckLoading = true;
                globalPlan = data;

                if (this.isPlanSyncWithGlobal(data)) {
                  _context20.next = 6;
                  break;
                }

                this.logger.info('updatePlanFromSocket 1', {
                  $truckLoading: this.$truckLoading
                });
                this.$truckLoading = false;
                return _context20.abrupt("return");

              case 6:
                if (!(this.$plan.trucks.length > 0 && globalPlan === null)) {
                  _context20.next = 16;
                  break;
                }

                this.$setPlan({
                  isReset: true
                });
                this.$resetPlan();
                this.$isPlanExists = false;
                this.logger.info('updatePlanFromSocket - Get Unassigned Orders');
                _context20.next = 13;
                return this.$getUnassignedOrders();

              case 13:
                this.logger.info('updatePlanFromSocket 2', {
                  $truckLoading: this.$truckLoading
                });
                this.$truckLoading = false;
                return _context20.abrupt("return");

              case 16:
                bufferPlan = this.helper.cloneDeep(this.$plan);

                if (this.$selectedTruck && this.$plan.trucks.length > 0) {
                  myTruck = this.currPlanTruck;
                  orders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(bufferPlan['orders']), (0, _toConsumableArray2.default)(globalPlan['orders'])), 'id');
                  trucks = [myTruck].concat((0, _toConsumableArray2.default)(globalPlan['vehicles'].filter(function (t) {
                    return t.truckId !== _this33.$selectedTruck;
                  })));
                  bufferPlan['planId'] = this.helper.flatten(trucks && trucks.length >= 1 ? trucks.map(function (i) {
                    return i.planId;
                  }) : []);
                  bufferPlan['orderId'] = orders.map(function (i) {
                    return i.id;
                  });
                  bufferPlan['orders'] = orders;
                  bufferPlan['truckId'] = trucks.map(function (i) {
                    return i.truckId;
                  });
                  bufferPlan['trucks'] = trucks;
                } else {
                  bufferPlan = {
                    code: globalPlan['code'],
                    planDate: globalPlan['code'],
                    planId: this.helper.flatten(globalPlan['vehicles'] && globalPlan['vehicles'].length >= 1 ? globalPlan['vehicles'].map(function (i) {
                      return i.planId;
                    }) : []),
                    orderId: globalPlan['orderIds'],
                    orders: globalPlan['orders'],
                    truckId: globalPlan['vehicles'].map(function (i) {
                      return i.truckId;
                    }),
                    trucks: globalPlan['vehicles'] || []
                  };
                }

                this.$setPlan({
                  plan: bufferPlan
                });
                this.$isPlanExists = true;
                this.logger.info('updatePlanFromSocket 2 - Get Unassigned Orders');
                _context20.next = 23;
                return this.$getUnassignedOrders();

              case 23:
                this.logger.info('updatePlanFromSocket 3', {
                  $truckLoading: this.$truckLoading
                });
                this.$truckLoading = false;

              case 25:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function updatePlanFromSocket(_x23) {
        return _updatePlanFromSocket.apply(this, arguments);
      }

      return updatePlanFromSocket;
    }()
  }, {
    key: "getAvailableVehicles",
    value: function getAvailableVehicles() {
      var _this34 = this;

      var vehileData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var finalVehicle = [];
      vehileData.forEach(function (vData) {
        // NOTE: if manual assign pass existing routes
        // if (vData['type'] === 'AUTOASSIGN') {
        // 	const currentTruck: object | null = this.$plan.trucks.find((t) => t['truckId'] === vData['code']);
        // 	if (currentTruck && currentTruck['routes'].length >= 1) {
        // 		if (!currentTruck['routes'].find((ct) => ct['status'] === 'ASSIGNED')) {
        // 			vData['routes'] = [];
        // 			vData['orders'] = this.getCleanOrders(currentTruck['orderId'] || [], this.$plan.orders);
        // 			finalVehicle.push(vData);
        // 		}
        // 	} else {
        // 		vData['routes'] = [];
        // 		vData['orders'] = [];
        // 		finalVehicle.push(vData);
        // 	}
        // } else {
        // 	vData['routes'] = this.getRoutes(vData['code']);
        // 	vData['orders'] = [];
        // 	finalVehicle.push(vData);
        // }
        // NOTE: always adhoc based on new requirements
        if (!vData['vehicleIsLocked']) {
          vData['routes'] = _this34.getRoutes(vData['code']);
          vData['orders'] = [];
        } else {
          vData['routes'] = [];
          vData['orders'] = [];
        }

        finalVehicle.push(vData);
      });
      return finalVehicle;
    }
  }, {
    key: "getCleanOrders",
    value: function getCleanOrders() {
      var orderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (orderId.length >= 1 && orders.length >= 1) {
        return orders.filter(function (oData) {
          return orderId.includes(Number(oData['id']));
        });
      }

      return [];
    }
  }, {
    key: "getRouteNumbers",
    value: function getRouteNumbers(routes) {
      var routeNumber = {
        capacity1: 0,
        capacity2: 0,
        endTime: routes.length >= 1 ? routes[routes.length - 1]['endRunningTime'] : 0,
        time: Number(this.$userSetting['default7'] || 0) + Number(this.$userSetting['default8'] || 0),
        routeCount: routes.length,
        orderCount: 0
      };
      var runningOrderIds = [];
      routes.forEach(function (rData) {
        routeNumber['capacity1'] = routeNumber['capacity1'] + Number(rData['capacity1'] || 0);
        routeNumber['capacity2'] = routeNumber['capacity2'] + Number(rData['capacity2'] || 0);
        routeNumber['time'] = routeNumber['time'] + Number(rData['time'] || 0) + Number(rData['handlingTime'] || 0) + Number(rData['waitingTime'] || 0);

        if (rData['waypointType'] && rData['orderId'] && rData['waypointType'] === 'D' && rData['orderId'].length >= 1) {
          runningOrderIds = [].concat((0, _toConsumableArray2.default)(runningOrderIds), (0, _toConsumableArray2.default)(rData['orderId']));
        }
      });
      routeNumber['orderCount'] = (0, _toConsumableArray2.default)(new Set(runningOrderIds)).length;
      return routeNumber;
    }
  }, {
    key: "isTruckOrderSentToWarehouse",
    value: function isTruckOrderSentToWarehouse() {
      var truckId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$selectedTruck;

      if (!truckId) {
        return false;
      }

      var truck = this.getTruckInPlan(truckId);
      return this.helper.get(truck, 'sendToWarehouse', false);
    }
  }]);
  return LastMileDeliveryMixin;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _userLogs.UserLogsMixin));

exports.LastMileDeliveryMixin = LastMileDeliveryMixin;
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfCustKey', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfCustKey", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfAPIToken', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfAPIToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('drivers', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$drivers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('plan', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$plan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultPagination', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$defaultPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultOrderColumns', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$defaultOrderColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('tableLoading', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$tableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('orderLocationLists', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$orderLocationLists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultLocationType', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$defaultLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isOccupied', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$isOccupied", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('occupyingUsername', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$occupyingUsername", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('occupyingRoute', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$occupyingRoute", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_MOBILE', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$setIsMobile", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SOCKET_ID', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$setSocketId", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TO_BE_UNASSIGNED_ORDER_IDS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setToBeUnassignedOrderIds", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setPlanDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DATE_RANGE_OPTION', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setDateRangeOption", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TABLE_LOADING', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setTableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_EXCLUDED_ORDERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setExcludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_INCLUDED_ORDERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setIncludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_ORDERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_DRIVER', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setSelectedDriver", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_TRUCK', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setSelectedTruck", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_LOADING', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setTruckLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DISABLE_TRUCK_LIST', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setDisableTruckList", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCKS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_BUFFER_TRUCKS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setBufferTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ANY_CHANGES', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setAnyChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_EXISTS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setPlanExists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PAGINATION', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_FILTERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setOrderFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_COLUMNS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setSelectedColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_FILTERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setTruckFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_UNASSIGNED_ORDERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_LOCATION_TYPE', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_LOCATION', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setSelectedLocation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SEARCH_TYPE', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setSearchType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_MANUAL_ASSIGN_LOADING', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setIsManualAssignLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_AUTO_ASSIGN_LOADING', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setIsAutoAssignLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ASSIGNED_DRIVER_CHANGES', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setIsAssignedDriverChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_FAILED_ORDERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setFailedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_COLUMN_TEMPLATES', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setOrderColumnTemplates", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_ACTIVE_USERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setGlobalActiveUsers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_ORDERS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setGlobalSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_TRUCKS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setGlobalSelectedTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_START_DATE', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setStartDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_END_DATE', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setEndDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_REMOVED_TRUCK_IDS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setRemovedTruckIds", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_OCCUPIED', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setIsOccupied", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_OCCUPYING_USERNAME', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setOccupyingUsername", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_OCCUPYING_ROUTE', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setOccupyingRoute", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PICK_UP_ALL_FIRST', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setPickUpAllFirst", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TIMEWINDOW_PRIORITY', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setTimeWindowPriority", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TIMEWINDOW_BUFFER', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setTimeWindowBuffer", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ADJUST_ETA', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setAdjustETA", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_CURR_TRUCK_PLAN_ID', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setCurrTruckPlanId", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_ENABLE_ALL_TRUCKS', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setIsEnableAllTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('resetPlan', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$resetPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('initPlan', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$initPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setPlan', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getUnassignedOrders', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$getUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setDateRange', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$setDateRange", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('deletePlan', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$deletePlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getTrucks', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$getTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getOrderLocationLists', {
  namespace: 'lastMileV2'
})], LastMileDeliveryMixin.prototype, "$getOrderLocationLists", void 0);
exports.LastMileDeliveryMixin = LastMileDeliveryMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], LastMileDeliveryMixin);